import { Injectable } from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AppSettingsService} from './appsettings.service';
import {AppSettings} from '../app.settings';
import {OBViewModel} from '../models/OBViewModel';



@Injectable({
  providedIn: 'root'
})


export class PagesService {

  urlString: string;
  private settings: AppSettings;
  private enrollId: string;



GETGENERALFORMENDPOINT: string;
GETEXAMFORMENDPOINT: string;
GETBRANCHNUMBERENDPOINT: string;
// add new changes to code
// GETCONSRAPPLICANTENDPOINT: string;
// POSTAPPLICANTENDPOINT: string;
GETGENERALFORMDETAILSENDPOINT: string;
GETEDUCATIONFORMDETAILSENDPOINT: string;
GETWORKHISTORYFORMDETAILSENDPOINT: string;
GETREFERENCEFORMDETAILSENDPOINT: string;
GETNEARESTOFFICEENDPOINT: string;
GETWIZARDSTEPSSENDPOINT: string;
GETAPPLICANTDETAILSTOPOSTENDPOINT: string;

PATCHGENERALENDPOINT: string;
PATCHCONSUMERGENERALENDPOINT: string;
PATCHEXAMENDPOINT: string;
POSTEDUCATIONENDPOINT: string;
POSTWORKHISTORYENDPOINT: string;
POSTREFERENCESENDPOINT: string;

UPDATEAUTOSTATUSENDPOINT: string;


headers: HttpHeaders = new HttpHeaders(
{
    'Content-Type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': '*' ,
    Authorization: 'Bearer ' + localStorage.getItem('auth_token')
});




  constructor(private httpClient: HttpClient, private appSettingsService: AppSettingsService) {

  this.enrollId = localStorage.getItem('id');


  this.appSettingsService.getSettings().subscribe(settings => this.settings = settings,
  () => null,
  () => {
    this.urlString = this.settings.lhcsaAPI;
  });


  this.GETGENERALFORMENDPOINT = this.urlString + '/api/General/GetGeneralForm/?';
  this.GETEXAMFORMENDPOINT = this.urlString + '/api/Exam/GetExamQuestionsAndAnswersForApplicant/?';

  this.GETNEARESTOFFICEENDPOINT = this.urlString + '/api/General/GetNearestOfficeListing/?';
  this.GETGENERALFORMDETAILSENDPOINT = this.urlString + '/api/General/GetGeneralFormDetails/?';

  this.GETBRANCHNUMBERENDPOINT = this.urlString + '/api/Applicants/GetOfficeNumber/?';

  this.GETEDUCATIONFORMDETAILSENDPOINT = this.urlString + '/api/Education/GetEducationDetails/?';
  this.GETWORKHISTORYFORMDETAILSENDPOINT = this.urlString + '/api/WorkHistory/GetWorkHistoryDetails/?';
  this.GETREFERENCEFORMDETAILSENDPOINT  = this.urlString + '/api/Reference/GetReferenceDetails/?';
  this.GETWIZARDSTEPSSENDPOINT = this.urlString + '/api/General/getWizardSteps/?';
  this.GETAPPLICANTDETAILSTOPOSTENDPOINT = this.urlString + '/api/OnBase/GetApplicantDetailsToPost/?';
  this.PATCHGENERALENDPOINT = this.urlString + '/api/General/UpdateGeneralForm/?';
  this.PATCHCONSUMERGENERALENDPOINT = this.urlString + '/api/AdminConsR/UpdateApplication/?';
  this.POSTEDUCATIONENDPOINT = this.urlString + '/api/Education/UpdateEducation/';
  this.POSTWORKHISTORYENDPOINT = this.urlString + '/api/WorkHistory/UpdateWorkHistory/';
  this.POSTREFERENCESENDPOINT = this.urlString + '/api/Reference/UpdateReferences/';
  this.PATCHEXAMENDPOINT = this.urlString + '/api/Exam/PostSaveAndScoreApplicantExamAnswers/';

  this.UPDATEAUTOSTATUSENDPOINT = this.urlString + '/api/Applicants/UpdateAutoStatus';

   }



   getGeneralFormDetails(ID: any): Observable<any> {

    const params = new HttpParams().set('ID', ID);

    return this.httpClient.get<any>(this.GETGENERALFORMENDPOINT, {headers : this.headers, params});
   }


   getExamDetails(formID: string, examID: string): Observable<any> {

    const params = new HttpParams().set('ApplicantFormId', formID)
    .set('ApplicantExamId', examID);

    return this.httpClient.get<any>(this.GETEXAMFORMENDPOINT, {headers : this.headers, params});
   }


   getEducationFormDetails(ID: any): Observable<any> {

    const params = new HttpParams().set('ID', ID);

    return this.httpClient.get<any>(this.GETEDUCATIONFORMDETAILSENDPOINT, {headers : this.headers, params});
   }


   getWorkHistoryFormDetails(ID: any): Observable<any> {

    const params = new HttpParams().set('ID', ID);

    return this.httpClient.get<any>(this.GETWORKHISTORYFORMDETAILSENDPOINT, {headers : this.headers, params});
   }


   getWorkReferenceDetails(ID: any): Observable<any> {

    const params = new HttpParams().set('ID', ID);

    return this.httpClient.get<any>(this.GETREFERENCEFORMDETAILSENDPOINT, {headers : this.headers, params});
   }


   getWizardStepDetails(wizchoice: any): Observable<any> {

    const params = new HttpParams().set('branchId', wizchoice.branchId)
                                  .set('position', wizchoice.position)
                                  .set('appId', wizchoice.appId);

    return this.httpClient.get<any>(this.GETWIZARDSTEPSSENDPOINT, {headers : this.headers, params});
   }



   getNearestOffice(LocVal: any, lang: string): Observable<any> {

    const params = new HttpParams()
    .set('LocationValue', LocVal)
    .set('lang', lang);

    return this.httpClient.get<any>(this.GETNEARESTOFFICEENDPOINT, {headers : this.headers, params});
   }


   getOfficeNumber(appID: string): Observable<any> {

    const params = new HttpParams()
    .set('appID', appID);


    return this.httpClient.get<any>(this.GETBRANCHNUMBERENDPOINT, {headers : this.headers, params});
   }


   getAppDetailsToPost(): Observable<OBViewModel> {

    const params = new HttpParams().set('ID', this.enrollId);

    return this.httpClient.get<any>(this.GETAPPLICANTDETAILSTOPOSTENDPOINT, {headers : this.headers, params});
   }




   updateAutoStatus(updatedApplicant: any): Observable<any> {
    // console.log('TestPost', JSON.stringify(updatedConsumer));
    const currentuser = localStorage.getItem('currentUser');
    const obj = JSON.parse(currentuser);

    // console.log('RecordToPost', JSON.stringify(updatedconsumer[0].jsonpatchobject));
    return this.httpClient.put<any>(this.UPDATEAUTOSTATUSENDPOINT, updatedApplicant, {
      headers: this.headers,
    });
  }



   updateExams(examdata: any): Observable<any> {

    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<any>(this.PATCHEXAMENDPOINT, examdata, {headers : this.headers});

  }



   updateGeneral(updatedgeneral: any): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.patch<any>(this.PATCHGENERALENDPOINT + 'id=' + this.enrollId, updatedgeneral, {headers : this.headers});

  }


  updateEducation(educationdata: any): Observable<any> {
    const data = JSON.stringify(educationdata);
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<any>(this.POSTEDUCATIONENDPOINT, data, {headers : this.headers});

  }


  updateWorkHistory(workdata: any): Observable<any> {

    const data = JSON.stringify(workdata);
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<any>(this.POSTWORKHISTORYENDPOINT, data, {headers : this.headers});

  }


  updateReferences(refdata: any): Observable<any> {

    const data = JSON.stringify(refdata);
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<any>(this.POSTREFERENCESENDPOINT, data, {headers : this.headers});

  }



   }



